(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('HubspotLead', HubspotLead);

    HubspotLead.$inject = ['$resource'];

    function HubspotLead ($resource) {
        var resourceUrl =  'api/hubspot-leads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
